/**
 * Tenant misc keys for destinations that require the Connections page
 * (OAuth / platform authorization before export).
 * Extend this list when new connection-backed destinations ship.
 */
export const CONNECTION_REQUIRING_MISC_KEYS = ['meta'] as const;

/** Misc key union for connection-requiring export destinations. */
export type ConnectionRequiringMiscKey =
  (typeof CONNECTION_REQUIRING_MISC_KEYS)[number];
